import { render, staticRenderFns } from "./DeliveryTimeModel.vue?vue&type=template&id=61894db4&scoped=true&"
import script from "./DeliveryTimeModel.vue?vue&type=script&lang=js&"
export * from "./DeliveryTimeModel.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTimeModel.vue?vue&type=style&index=0&id=61894db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61894db4",
  null
  
)

export default component.exports